__turbopack_context__.v({
  "article": "Article-module-scss-module__3A8Kya__article",
  "section": "Article-module-scss-module__3A8Kya__section",
});
